// 난이도별 그라데이션 색상 (Level 1 → Level 5) - 단색 녹색 그라데이션
/* eslint-disable no-restricted-syntax */
export const DIFFICULTY_COLORS = [
  'rgba(253, 224, 71, 0.7)',  // Level 1 - yellow-300 (파스텔 노란색, 85% 불투명도)
  'rgba(134, 239, 172, 0.7)', // Level 2 - green-300 (파스텔 녹색, 85% 불투명도)
  'rgba(147, 197, 253, 0.7)', // Level 3 - blue-300 (파스텔 파란색, 85% 불투명도)
  'rgba(253, 186, 116, 0.7)', // Level 4 - orange-300 (파스텔 주황색, 85% 불투명도)
  'rgba(252, 165, 165, 0.7)'  // Level 5 - red-300 (파스텔 빨간색, 85% 불투명도)
];
/* eslint-enable no-restricted-syntax */

// report_status에 따른 아이콘 색상과 툴팁
export const REPORT_STATUS_INFO = {
  0: { color: 'bg-gray-400', tooltip: '리포트 없음' },
  100: { color: 'bg-yellow-500', tooltip: '생성 요청됨' },
  101: { color: 'bg-orange-500', tooltip: '생성 중' },
  102: { color: 'bg-red-500', tooltip: '생성 오류' },
  150: { color: 'bg-purple-500', tooltip: '편집 중' },
  200: { color: 'bg-blue-500', tooltip: '준비 완료(미확정)' },
  998: { color: 'bg-blue-500', tooltip: '준비 완료(미확정)' },
  999: { color: 'bg-green-500', tooltip: '확정 완료' }
};

// 결과맵 상태별 색상
export const RESULT_MAP_STATUS_COLORS = {
  200: 'bg-primary',
  201: 'bg-primary bg-opacity-70',
  100: 'bg-danger',
  101: 'bg-danger bg-opacity-70',
  500: 'bg-warning',
  0: 'bg-gray-200'
};

// 페이지네이션 설정
export const ITEMS_PER_PAGE = 20;
export const TESTS_PER_PAGE = 10;

// 모바일 뷰 브레이크포인트
export const MOBILE_BREAKPOINT = 720;

// API 엔드포인트
export const API_ENDPOINTS = {
  STUDENTS: '/api/users/student',
  EXAMS: '/api/exams',
  EXAMS_SUMMARY: '/api/exams/summary', // 새로운 통합 API
  RESULT_MAP: '/api/resultmap',
  PROBLEMS_PRINT: '/api/problems/print'
};

// 테스트 상태
export const TEST_STATUS = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed'
};

// 시험 상태 코드
export const EXAM_STATUS = {
  COMPLETED: 999,
  IN_PROGRESS: 200
};

// 기본값
export const DEFAULTS = {
  RATING: 1000,
  DIFFICULTY: 250,
  EXAM_LENGTH: 25,
  Y_AXIS_MARGIN: 100
}; 